'use es6';

import { Record } from 'immutable';
const KeywordBasicRecord = Record({
  keywordText: null,
  matchType: null,
  id: null
});
export default KeywordBasicRecord;